module.exports = __webpack_public_path__ + "static/fipcballoonanimalmain-d74d8d754f23bab1d7d31821f9907ff1.jpeg";